import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["badge"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useQueryClient } from 'react-query';
import { useState } from 'react';
import toArray from 'utils/toArray';
import { useUpdatePlaylistBadge } from 'actions/badges';
import { useUpdatePlaylists, playlistQueryKeys } from 'actions/playlists';
import { formatPlaylistEditorPayloadForApi } from '../utils/formatPlaylistEditorPayloadForApi';
export function useSubmitPlaylistEditor(_ref) {
  var playlistId = _ref.playlistId,
    parentPlaylistId = _ref.parentPlaylistId,
    ownerTeamId = _ref.ownerTeamId,
    badge = _ref.badge,
    onSuccess = _ref.onSuccess;
  var queryClient = useQueryClient();
  var playlistIds = toArray(playlistId);
  var isSinglePlaylist = playlistIds.length === 1;
  var _useUpdatePlaylists = useUpdatePlaylists({
      playlistIds: playlistIds,
      ownerTeamId: ownerTeamId
    }),
    updatePlaylists = _useUpdatePlaylists.updatePlaylists;
  var _useUpdatePlaylistBad = useUpdatePlaylistBadge(isSinglePlaylist ? playlistId[0] : undefined, badge),
    updatePlaylistBadge = _useUpdatePlaylistBad.updatePlaylistBadge;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmissionLoading = _useState2[0],
    setIsSubmissionLoading = _useState2[1];
  function submitPlaylistEditor(_x) {
    return _submitPlaylistEditor.apply(this, arguments);
  }
  function _submitPlaylistEditor() {
    _submitPlaylistEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var newBadgeData, playlistChanges, invalidationPromises;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newBadgeData = payload.badge, playlistChanges = _objectWithoutProperties(payload, _excluded);
            setIsSubmissionLoading(true);
            _context.prev = 2;
            if (!(Object.keys(playlistChanges).length > 0)) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return updatePlaylists(formatPlaylistEditorPayloadForApi(playlistChanges));
          case 6:
            if (!(newBadgeData && isSinglePlaylist)) {
              _context.next = 9;
              break;
            }
            _context.next = 9;
            return updatePlaylistBadge({
              contentId: playlistIds[0],
              badgeId: badge === null || badge === void 0 ? void 0 : badge.id,
              imageId: newBadgeData.imageId
            });
          case 9:
            invalidationPromises = [queryClient.invalidateQueries(playlistQueryKeys.multiPlaylistsDetails(playlistIds)), queryClient.invalidateQueries(playlistQueryKeys.playlistList())].concat(_toConsumableArray(playlistIds.map(function (id) {
              return queryClient.invalidateQueries(playlistQueryKeys.singlePlaylist(id));
            })));
            if (parentPlaylistId) {
              invalidationPromises.push(queryClient.invalidateQueries(playlistQueryKeys.singlePlaylist(parentPlaylistId)));
            }
            _context.next = 13;
            return Promise.all(invalidationPromises);
          case 13:
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            setIsSubmissionLoading(false);
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](2);
            setIsSubmissionLoading(false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 17]]);
    }));
    return _submitPlaylistEditor.apply(this, arguments);
  }
  return {
    submitPlaylistEditor: submitPlaylistEditor,
    isSubmissionLoading: isSubmissionLoading
  };
}